'use client'
import React, {createContext, useEffect, useState} from 'react';
import useWindowDimensions from "@/libs/contentful/helper/useWindowDimension";

interface Props {
    children?: React.ReactNode
}

export const MobileNavContext = createContext({
    isMobileNavExpanded: false,
    toggleMobileNav:  (value:boolean) => {value},
});

export const MegaMenuContext = createContext({
    isMegaMenuOpen: false,
    toggleMegaMenu:  (value:boolean) => {value},
});

export function MobileNavProvider({ children }:Props) {
    const [isMobileNavExpanded, toggleMobileNav] = useState(false)
    const { width } = useWindowDimensions();
    useEffect(() => {
        if (isMobileNavExpanded && width !== undefined && width < 834) {
            document.body.classList.add("overflow-y-hidden")
            document.body.classList.add("md:overflow-y-visible")
        } else {
            document.body.classList.remove("overflow-y-hidden")
            document.body.classList.remove("md:overflow-y-visible")
        }
    })
    return (
        <MobileNavContext.Provider value={{isMobileNavExpanded, toggleMobileNav}}>
            {children}
        </MobileNavContext.Provider>
    );
}

export function MegaMenuProvider({ children }:Props) {
    const [isMegaMenuOpen, toggleMegaMenu] = useState(false)
    const { width } = useWindowDimensions();

    return (
        <MegaMenuContext.Provider value={{isMegaMenuOpen, toggleMegaMenu}}>
            <li className={"group border-b-[1px] border-b-brand-light-cool-grey md:my-auto md:border-none " + (width !== undefined && width < 834 && isMegaMenuOpen ? 'bg-brand-light-cool-grey' : '')}
                onMouseEnter={() => width !== undefined && width > 833 ? toggleMegaMenu(true) : null}
                onMouseLeave={() => width !== undefined && width > 833 ? toggleMegaMenu(false) : null}
                onBlur={(e) => width !== undefined && width > 833 && !e.currentTarget.contains(e.relatedTarget) ? toggleMegaMenu(false) : null}
                onClick={(e) => width !== undefined && width < 834 && (e.target as HTMLInputElement).getAttribute('target') !== '_blank' ? toggleMegaMenu(!isMegaMenuOpen) : null}
            >
                {children}
            </li>
        </MegaMenuContext.Provider>
    );
}